<script>
import { fly } from 'svelte/transition';
export let width;
export let image;
export let linkto;
export let alt;

const domain = window.location.hostname;
const defaultWidth = domain.includes('vntpoint') ? 120 : 140;
width = width || defaultWidth;

const logoSettings = {
    'covecreekproductions': {
        image: './images/cc_white.png',
        linkto: 'https://covecreekproductions.com/',
        alt: 'Made by CoveCreek Productions'
    },
    'vntpoint': {
        image: './images/vp_white.png',
        linkto: 'https://vntpoint.com/',
        alt: 'Made by Vantage Point'
    },
    'default': {
        image: './images/cc_white.png',
        linkto: 'https://covecreekproductions.com/',
        alt: 'Made by CoveCreek Productions'
    }
};

// Select the appropriate logo settings based on the domain
const selectedLogo = domain.includes('vntpoint')
    ? logoSettings['vntpoint']
    : logoSettings['covecreekproductions'];

// Use existing props or default to the selected logo settings
image = image || selectedLogo.image;
linkto = linkto || selectedLogo.linkto;
alt = alt || selectedLogo.alt;

function openUrl(){
    let win = window.open(linkto, '_blank');
    win.focus();
}
</script>

<style>
    div {
        position: absolute;
        right: 8px;
        bottom: 8px;
        z-index: 999;
        cursor:pointer;
    }
    
    img {
        height: auto;
        opacity: 0.60;
    }

    img:hover {
        opacity: 1;
    }

    @media only screen and (max-width: 600px) {
        div {
            display: none;
        }
    }
</style>

<div on:click={openUrl}  transition:fly={{y: 300, duration: 500 }}>
    <img src={image} width={width} alt={alt}/>
</div>
